// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KjBZ","clinicsSelect":"styles_clinicsSelect__g61tV"};